import api from "./axios";

// --- Templates (master CRUD) ---
export const listPaymentMasters = (params = {}) =>
  api.get("/payment-masters", { params });
export const getPaymentMaster = (id) => api.get(`/payment-masters/${id}`);
export const createPaymentMaster = (payload) =>
  api.post("/payment-masters", payload);
export const updatePaymentMaster = (id, payload) =>
  api.patch(`/payment-masters/${id}`, payload);
export const deletePaymentMaster = (id) =>
  api.delete(`/payment-masters/${id}`);

// --- Per-business attachment ---
export const listBusinessPaymentMasters = (businessId) =>
  api.get(`/businesses/${businessId}/payment-masters`);
export const attachBusinessPaymentMaster = (businessId, payload) =>
  api.post(`/businesses/${businessId}/payment-masters`, payload);
export const updateBusinessPaymentMaster = (businessId, masterId, payload) =>
  api.patch(`/businesses/${businessId}/payment-masters/${masterId}`, payload);
export const detachBusinessPaymentMaster = (businessId, masterId) =>
  api.delete(`/businesses/${businessId}/payment-masters/${masterId}`);

// --- Phase 2: instances + ops ---
export const listPaymentInstances = (params = {}) =>
  api.get("/payment-instances", { params });
export const getPaymentInstance = (id) =>
  api.get(`/payment-instances/${id}`);
export const updatePaymentInstance = (id, payload) =>
  api.patch(`/payment-instances/${id}`, payload);
export const deletePaymentInstance = (id) =>
  api.delete(`/payment-instances/${id}`);
export const paymentInstanceStats = () =>
  api.get("/payment-instances/stats");

export const opsGeneratePayments = (payload = {}) =>
  api.post("/ops/payments/generate", payload);
export const opsSweepOverduePayments = (payload = {}) =>
  api.post("/ops/payments/sweep-overdue", payload);
export const opsSendPaymentReminders = (payload = {}) =>
  api.post("/ops/payments/send-reminders", payload);
// Auto-invoiced tasks. Single `date` only — no from/to range, since these
// bills carry no payment master and so have no DB-level dedupe.
export const opsIssueTaskInvoices = (payload = {}) =>
  api.post("/ops/payments/issue-task-invoices", payload);

// --- Phase 3: receipts (splits = multiple receipts per instance) ---
export const createReceipt = (instanceId, payload) =>
  api.post(`/payment-instances/${instanceId}/receipts`, payload);
export const updateReceipt = (receiptId, payload) =>
  api.patch(`/payment-receipts/${receiptId}`, payload);
export const deleteReceipt = (receiptId) =>
  api.delete(`/payment-receipts/${receiptId}`);

// --- Expenses: line items folded into a bill's expected_amount ---
export const createExpense = (instanceId, payload) =>
  api.post(`/payment-instances/${instanceId}/expenses`, payload);
export const updateExpense = (expenseId, payload) =>
  api.patch(`/payment-expenses/${expenseId}`, payload);
export const deleteExpense = (expenseId) =>
  api.delete(`/payment-expenses/${expenseId}`);
